import { useEffect, useState } from 'react';

//styles
import {
  LanguageSelector,
  LanguageWrapper,
  LanguageSelectorButton,
  LanguageList,
  LanguageOption,
} from './LangSelector.styles';

import { LangButton } from '@/components/LangButton';

export default function LangSelector({ language }) {
  const lang_options = {
    pt: {
      short: 'pt',
      long: 'Português',
      url: '/pt/subscription-and-professional-services-agreement/',
    },
    es: {
      short: 'es',
      long: 'Español',
      url: '/es/subscription-and-professional-services-agreement/',
    },
    en: {
      short: 'en',
      long: 'English',
      url: '/subscription-and-professional-services-agreement/',
    },
  };
  const lang = language;
  const [menuLanguageOpen, setMenuLanguageOpen] = useState(false);

  const closeDropdownWhenClickOutside = () => {
    document.addEventListener('click', function (event) {
      const isClickInsideElement = document
        .getElementById('lang-selector-menu')
        .contains(event.target);
      if (!isClickInsideElement) {
        setMenuLanguageOpen(false);
      }
    });
  };

  useEffect(() => {
    if (menuLanguageOpen) {
      closeDropdownWhenClickOutside();
    }
  }, [menuLanguageOpen]);

  return (
    <LanguageSelector id="lang-selector-menu">
      <LanguageWrapper>
        <LanguageSelectorButton
          as="button"
          onClick={() => setMenuLanguageOpen(!menuLanguageOpen)}
          title={lang}
        >
          <span>{lang_options[lang].long}</span>

          <LangButton color="gray" label={lang.toUpperCase()} />
        </LanguageSelectorButton>
        <LanguageList className={menuLanguageOpen ? `open` : ``}>
          <LanguageOption as="a" href={lang_options['en'].url}>
            <span>English</span>
            <LangButton color="gray" label="EN" />
          </LanguageOption>
          <LanguageOption as="a" href={lang_options['es'].url}>
            <span>Español</span>
            <LangButton color="gray" label="ES" />
          </LanguageOption>
          <LanguageOption as="a" href={lang_options['pt'].url}>
            <span>Português</span>
            <LangButton color="gray" label="PT" />
          </LanguageOption>
        </LanguageList>
      </LanguageWrapper>
    </LanguageSelector>
  );
}

export { LangSelector };
